
try {
    window.moment = require('moment');
    require('bootstrap-datepicker');
    require('../../../../node_modules/bootstrap-datepicker/dist/locales/bootstrap-datepicker.es.min');
    //require('../../../../node_modules/bootstrap-datepicker/dist/locales/bootstrap-datepicker.en-GB.min');
    require('../../../../node_modules/bootstrap-datepicker/dist/locales/bootstrap-datepicker.nl-BE.min');
    require('../../../../node_modules/bootstrap-datepicker/dist/locales/bootstrap-datepicker.fr.min');

} catch (e) {
    console.log(e);
}


